// Globální objekt App — tlačítka v HTML volají App.něco() (onclick).
// Musí existovat dřív, než se načtou moduly, které do něj přidávají funkce.
window.App = window.App || {};
